import React, {ReactElement, useCallback, useMemo} from 'react';
import DialogTitle from "@mui/material/DialogTitle";
import {Dialog, IconButton, Stack, Typography} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import {DailyTransferSchedule} from "../ActivityReservations/DailyTransferSchedule";
import {toISODateString} from "../../services/toISODateString";
import {v4 as uuidv4} from "uuid";
import Paper, {PaperProps} from "@mui/material/Paper";
import Draggable from "react-draggable";
import {TransitionProps} from "@mui/material/transitions";
import Slide from '@mui/material/Slide';
import { useStateContext } from '../../hooks/useStateContext';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const TransferScheduler = ({
                                    onClose,
                                  }: {
  onClose: ()=> void;
}): ReactElement => {

  const { viewPeriod } = useStateContext();
  
  const draggablePaneId = useMemo(() => {
    return `draggable-responsive-add-new-dialog-${uuidv4()}`;
  }, []);

  const PaperComponent = useCallback((props: PaperProps) => {
    return (
      <Draggable
        handle={`#${draggablePaneId}, .drag-handle`}
        cancel={'[class*="MuiDialogContent-root"], .non-draggable-button'}
      >
        <Paper {...props} />
      </Draggable>
    );
  }, []);
  
  return (
    <>
      <Dialog
        open={true}
        onClose={() => onClose()}
        fullWidth
        PaperComponent={PaperComponent}
        fullScreen
        TransitionComponent={Transition}
        sx={{
          '& .MuiPaper-root.MuiDialog-paper': {
            maxWidth: 'calc(100% - 180px)',
            height: 'calc(100% - 100px)',
          },
        }}
      >
        <DialogTitle>
          <Stack
            direction={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}
          >
            <Stack direction={'column'} alignItems={'flex-start'}>
              <Typography variant="subtitle1">Transfer Scheduler</Typography>
            </Stack>
            <Stack direction={'row'} alignItems={'center'}>
              <IconButton
                aria-label="Close"
                className="non-draggable-button"
                sx={{
                  color: '#5f5f5f',
                }}
                onClick={() => {
                  onClose();
                }}
              >
                <CloseIcon />
              </IconButton>
            </Stack>
          </Stack>
        </DialogTitle>

        <DialogContent>
          <DailyTransferSchedule
            weekView={true}
            date={toISODateString(viewPeriod[0])}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};
